// extracted by mini-css-extract-plugin
module.exports = {"pages_transfer":"pagesTransfer_pages_transfer__3Je4K"};